import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { joinBy } from '@pbk/utils';
import { forwardRef } from 'react';
import { sizes } from '../../../const/sizes';
import { Box } from '../../layout/Box';
import { FlexContainer } from '../../layout/FlexContainer';
import { NormalInputBase } from '../NormalInputBase';
import { usePhoneNumberInput } from '../PhoneNumberInput/usePhoneNumberInput';
import { SelectCombobox } from '../Select/SelectCombobox/SelectCombobox';
const PHONE_INPUT_WIDTH = sizes.phoneNumberInput.phoneInputWidth;
const SELECT_PREFIX_MIN_WIDTH = sizes.phoneNumberInput.selectPrefixMinWidth;
export const PhoneNumberComboboxInput = forwardRef(({ phonePrefixes, phonePrefix = '', phoneNumberWithoutPrefix = '', maxPhoneCharacterCount, prefixLabel, onValueChange, readOnly, required, isRequiredLabel, disabled, autoComplete, prefixPlaceholder, prefixTestId, prefixError, prefixSearchPlaceholder, ...inputPhoneProps }, ref) => {
    const { prefix, handleChange, handleChangePrefix } = usePhoneNumberInput({
        phonePrefix,
        phoneNumberWithoutPrefix,
        maxPhoneCharacterCount,
        onValueChange,
    });
    const prefixOptions = phonePrefixes.map(({ prefix: prefixValue, countryName }) => ({
        value: prefixValue,
        text: joinBy([prefixValue, countryName], ' - '),
        testId: prefixValue,
    }));
    const commonProps = {
        readOnly,
        required,
        isRequiredLabel,
        disabled,
        autoComplete,
    };
    return (_jsxs(FlexContainer, { gap: true, children: [_jsx(Box, { minWidth: SELECT_PREFIX_MIN_WIDTH, children: _jsx(SelectCombobox, { ...commonProps, label: prefixLabel, options: prefixOptions, value: prefix, placeholder: prefixPlaceholder, error: prefixError, testId: prefixTestId, contentMinWidth: sizes.phoneNumberInput.selectPrefixDropdownMinWidth, searchPlaceholder: prefixSearchPlaceholder, triggerText: prefix, onValueChange: handleChangePrefix }) }), _jsx(Box, { width: PHONE_INPUT_WIDTH, children: _jsx(NormalInputBase, { ref: ref, ...commonProps, ...inputPhoneProps, type: 'tel', value: phoneNumberWithoutPrefix, onChange: handleChange }) })] }));
});
PhoneNumberComboboxInput.displayName = 'PhoneNumberComboboxInput';
